import { Component } from '@mycolorway/tao';
import { closest } from 'next/javascripts/modules/dom';
import baseMixin from './base';
import 'next/stylesheets/components/grid/cells/select-cell.scss';

Component('tr-grid-select-cell', {
  mixins: [baseMixin],

  connected() {
    this.listenTo(this, {
      click: this.handleClick.bind(this),
      'tr-selector-field:change': this.handleChange.bind(this),
      'tr-selector-field-list:opened': () => { this.editing = true; },
      'tr-selector-field-list:closed': () => { this.editing = false; },
    });
  },

  preventClickEvent({ target }) {
    return this.editable
      && closest(target, '.selector-field-result', this);
  },

  handleClick({ target }) {
    const field = closest(target, '.selector-field-result', this);
    if (field && !closest(field, '.grid-cell-editor', this)) {
      this.beginEditing();
    }
  },

  async beginEditing() {
    if (!this.editable || this.editing) return;

    await this.prepareEditor();
    this.destroyOverflowTooltip();
    if (!this.editor) return;

    this.editor.toggleList(true);
  },

  prepareEditor() {
    return new Promise(async (resolve) => {
      if (this.editorInitialized) {
        resolve();
      } else {
        this.editor = await this.editorLoader.editor;
        this.editorInitialized = true;
        if (!this.editor) {
          resolve();
          return;
        }

        const selectedOption = this.editor
          .querySelector(`select option[value="${this.value || 'blank'}"]`);
        if (selectedOption) selectedOption.selected = true;

        this.listenTo(this.editor, 'tao:ready', resolve, { once: true });
        this.replaceChild(this.editor, this.firstElementChild);
      }
    });
  },

  getTextContentElement() {
    const selectedText = this.querySelector('.selector-field-result .selected-text');
    if (selectedText.hasAttribute('data-label-color')) {
      return selectedText;
    }

    return selectedText.querySelector('.text');
  },

  handleChange(event) {
    const value = event.detail === 'blank' ? '' : event.detail;
    if (!value && !this.value) return;

    this.value = value;
    this.namespacedTrigger('cellValueChange', {
      detail: { value },
      bubbles: true,
    });
  },
});
